import axios from 'axios';
import { browserHistory } from 'react-router';
import moment from 'moment';

import {
  REQUEST_CUSTOMERS,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
  REQUEST_CUSTOMERS_PAGINATE,
  FETCH_CUSTOMERS_PAGINATE_SUCCESS,
  FETCH_CUSTOMERS_PAGINATE_FAILURE,
  REQUEST_CUSTOMERS_STATUS,
  FETCH_CUSTOMERS_STATUS_SUCCESS,
  FETCH_CUSTOMERS_STATUS_FAILURE,
  SELECT_CUSTOMER,
  RESET_CURRENT_CUSTOMER,
  REQUEST_CREATING_CUSTOMER,
  CREATE_CUSTOMER_SUCCESS,
  CREATE_CUSTOMER_FAILURE,
  REQUEST_EDITING_CUSTOMER,
  EDIT_CUSTOMER_SUCCESS,
  EDIT_CUSTOMER_FAILURE,
  REQUEST_CUSTOMER_DETAIL,
  FETCH_CUSTOMER_DETAIL_SUCCESS,
  FETCH_CUSTOMER_DETAIL_FAILURE,
  REQUEST_CUSTOMER_CREDIT_BY_DATE,
  FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS,
  FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE,
  ATTACH_DOCUMENT,
  ATTACH_DOCUMENT_SUCCESS,
  ATTACH_DOCUMENT_FAILURE,
  REQUEST_CUSTOMERS_OPTIONS,
  FETCH_CUSTOMERS_OPTIONS_SUCCESS,
  FETCH_CUSTOMERS_OPTIONS_FAILURE,
} from './type';
import {
  CUSTOMERS_URL,
  CUSTOMERS_PAGINATE_URL,
  CUSTOMER_CREDIT_LINES_URL,
  CUSTOMERS_STATUS_URL,
  UPLOAD_URL,
  FETCH_FJ_AGENTS_URL,
  FETCH_PRICE_TABLE_URL,
  AUTO_CUSTOMER_NUMBER_URL,
} from './url';
import {
  isGGI, ROOT_URL, ROOT_API_URL, isOLG, isLAP, isLE, isVAK,
} from './root_url';
import { DEFAULT_ERROR } from '../components/Common/constants';

const getOptionsValue = (option) => {
  if (typeof option === 'object' && option !== null) {
    return option.value
  } else {
    return option
  }
}

export function requestCustomers() {
  return {
    type: REQUEST_CUSTOMERS,
  };
}

export function fetchCustomersSuccess(customers) {
  return {
    type: FETCH_CUSTOMERS_SUCCESS,
    payload: customers,
  };
}

export function fetchCustomersFailure(error) {
  return {
    type: FETCH_CUSTOMERS_FAILURE,
    payload: error,
  };
}
export function requestCustomersOptions() {
  return {
    type: REQUEST_CUSTOMERS_OPTIONS,
  }
}

export function fetchCustomersOptionsSuccess(customers) {
  return {
    type: FETCH_CUSTOMERS_OPTIONS_SUCCESS,
    payload: customers,
  }
}

export function fetchCustomersOptionsFailure(error) {
  return {
    type: FETCH_CUSTOMERS_OPTIONS_FAILURE,
    payload: error,
  }
}

export function fetchCustomers(cb = () => {}, company_id) {
  return (dispatch) => {
    dispatch(requestCustomers());
    let company = '';
    if (company_id) {
      company = `?Company_id=${company_id}`
    }
    return axios.get(
      CUSTOMERS_URL + company,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomersSuccess(response));
        cb();
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchCustomersFailure(err));
        }
      });
  };
}

export function requestCustomersPaginate() {
  return {
    type: REQUEST_CUSTOMERS_PAGINATE,
  };
}

export function fetchCustomersPaginateSuccess(customers) {
  return {
    type: FETCH_CUSTOMERS_PAGINATE_SUCCESS,
    payload: customers,
  };
}

export function fetchCustomersPaginateFailure(error) {
  return {
    type: FETCH_CUSTOMERS_PAGINATE_FAILURE,
    payload: error,
  };
}

export function fetchCustomersPaginate(currentPage, limit, searchFilter) {
  if (!limit) { limit = 'all'; }
  currentPage = currentPage + 1;
  const url = `${CUSTOMERS_PAGINATE_URL}`;
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    // if (!selectedCompany) return;
    const params = {
      page: currentPage,
      limit: limit,
      CustomerNum: searchFilter.CustomerNum,
      Name: searchFilter.Name,
      SalesName: searchFilter.SalesName,
      Email: searchFilter.email,
      Description: searchFilter.Description,
      IsWholesale: searchFilter.IsWholesale,
      PriceLevel: searchFilter.PriceLevel,
      IsActive: searchFilter.IsActive,
      MemberCard: searchFilter.MemberCard,
      Reseller: searchFilter.Reseller,
      phone: searchFilter.Telephone,
      address: searchFilter.Street,
      City: searchFilter.City,
      Company_id: selectedCompany.value,
      Customer_id: searchFilter.Old_Customer_id,
      State: searchFilter.State,
      BusinessType: searchFilter.BusinessType,
      // CreateDateStart: searchFilter.CreateDateStart,
      // CreateDateEnd: searchFilter.CreateDateEnd,
      // LastOrderDateStart: searchFilter.LastOrderDateStart,
      // LastOrderDateEnd: searchFilter.LastOrderDateEnd,
    }
    if (searchFilter.CreateDateStart) {
      const CreateDate__gte = moment(searchFilter.CreateDateStart).startOf('day').toISOString();
      params.CreateDate__gte = CreateDate__gte;
    }
    if (searchFilter.CreateDateEnd) {
      const CreateDate__lte = moment(searchFilter.CreateDateEnd).endOf('day').toISOString();
      params.CreateDate__lte = CreateDate__lte;
    }
    if (searchFilter.LastOrderDateStart) {
      const LastOrderDate__gte = moment(searchFilter.LastOrderDateStart).startOf('day').toISOString();
      params.LastOrderDate__gte = LastOrderDate__gte;
    }
    if (searchFilter.LastOrderDateEnd) {
      const LastOrderDate__lte = moment(searchFilter.LastOrderDateEnd).endOf('day').toISOString();
      params.LastOrderDate__lte = LastOrderDate__lte;
    }
    dispatch(requestCustomersPaginate());
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params,
    }).then((response) => {
      dispatch(fetchCustomersPaginateSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchCustomersPaginateFailure(err));        
      }
    });
  };
}

export function fetchActiveCustomers(companyId = null) {
  return (dispatch, getState) => {
    dispatch(requestCustomers());
    const state = getState();
    let selectedCompany = state.header.selectedCompany;
    let Company_id;
    if (selectedCompany) {
      Company_id = selectedCompany.value;
    }
    if (companyId) {
      Company_id = companyId;
    }
    if (!Company_id) return;
    return axios({
      method: 'get',
      url: `${CUSTOMERS_URL}?Customer_id__IsActive=1&Company_id=${Company_id}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(fetchCustomersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchCustomersFailure(err));          
        }
      });
  };
}

export function fetchActiveCustomersOptions(companyId = null) {
  return (dispatch, getState) => {
    dispatch(requestCustomersOptions());
    const state = getState();
    let selectedCompany = state.header.selectedCompany;
    let Company_id;
    if (selectedCompany) {
      Company_id = selectedCompany.value;
    }
    if (companyId) {
      Company_id = companyId;
    }
    if (!Company_id) return;
    return axios({
      method: 'get',
      url: `${CUSTOMERS_URL}?Customer_id__IsActive=1&Company_id=${Company_id}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(fetchCustomersOptionsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchCustomersOptionsFailure(err));          
        }
      });
  }
}

export function selectCustomer(customer) {
  return {
    type: SELECT_CUSTOMER,
    payload: customer,
  };
}

export function resetCurrentCustomer() {
  return {
    type: RESET_CURRENT_CUSTOMER,
  };
}

// Actions to deal with the promise of posting function.
export function requestCreatingCustomer() {
  return {
    type: REQUEST_CREATING_CUSTOMER,
  };
}

export function createCustomerSuccess() {
  return {
    type: CREATE_CUSTOMER_SUCCESS,
  };
}

export function createCustomerFailure(error) {
  return {
    type: CREATE_CUSTOMER_FAILURE,
    payload: error,
  };
}

export function createCustomer({
  Billing,
  CreditLimit,
  CustomerNum,
  DeliverPlan_id,
  Description,
  ContactName,
  website,
  email,
  IsActive,
  IsPrtGeneralInfor,
  IsPrtReminder,
  IsShowPrice,
  IsWholesale,
  IsEmailInvoice,
  Mailing,
  Name,
  Notation,
  TeapplixCollectShippingProfile,
  Teapplix3rdPartyShippingProfile,
  Commission,
  Commission2,
  Note,
  PaymentTerm_id,
  PriceLevel,
  RefNum,
  Sales_User_id,
  Sales_User_id2,
  Shipping,
  Wholesale_ResaleNo,
  EIN,
  rating,
  OverdueTime,
  GracePeriod,
  OverdueAmount,
  DLN,
  Reseller,
  MemberCard,
  DiscountPercentage,
  bad_credit_reason,
  Customer_Service_id,
  AssociatedCompany,
  Old_Customer_id,
  Supervisor_id,
  CreateDate,
  StartDate,
  IsInternal,
  Route_id,
  Business_Phone = '',
  Discount,
  QuickbookAccount = '',
}, {
  businessType: BusinessType,
  creditStatus: CreditStatus,
  orderType: OrderType,
  IsStripe, Sub_Customer_id,
  Attachment1,
  Attachment2,
  Attachment3,
  Attachment4,
  Attachment5,
  Attachment6,
  Attachment7,
  Attachment8,
  AttachmentName1,
  AttachmentName2,
  AttachmentName3,
  AttachmentName4,
  AttachmentName5,
  AttachmentName6,
  AttachmentName7,
  AttachmentName8,
}) {
  // if(ControlledMailingAddress) {
  //   MailingAddress = {...ControlledMailingAddress};
  // }
  // if(ControlledMailingContact) {
  //   MailingContact = {...ControlledMailingContact};
  // }
  // if(ShippingAddress && currentShippingAddress) {
  //   if(ShippingAddress[0] && currentShippingAddress) {
  //     ShippingAddress[0] = {...ShippingAddress[0], ...currentShippingAddress};
  //   }
  // }
  // if(ShippingContact && currentShippingContact) {
  //   if(ShippingContact[0] && currentShippingContact) {
  //     ShippingContact[0] = {...ShippingContact[0], currentShippingContact};
  //   }
  // }
  if (Supervisor_id && Supervisor_id.value) {
    Supervisor_id = Supervisor_id.value
  }
  if (rating && rating.value) {
    rating = rating.value
  }
  if (Customer_Service_id && Customer_Service_id.value) {
    Customer_Service_id = Customer_Service_id.value;
  }
  if (AssociatedCompany && AssociatedCompany.value) {
    AssociatedCompany = AssociatedCompany.value;
  }
  if (PaymentTerm_id) {
    PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
  }
  if (Sales_User_id) {
    Sales_User_id = Sales_User_id.value || Sales_User_id;
  }
  if (Sales_User_id2) {
    Sales_User_id2 = Sales_User_id2.value || Sales_User_id2;
  }
  if (Billing && Billing.Duty && Billing.Duty.value) {
    Billing.Duty = Billing.Duty.value;
  }
  if (Billing && Billing.Title && Billing.Title.value) {
    Billing.Title = Billing.Title.value;
  }
  if (Mailing && Array.isArray(Mailing)) {
    Mailing = Mailing.map(mail => ({
      ...mail,
      Duty: getOptionsValue(mail.Duty),
      Title: getOptionsValue(mail.Title),
    }))
  }
  if (Shipping && Array.isArray(Shipping)) {
    Shipping = Shipping.map(ship => ({
      ...ship,
      Duty: getOptionsValue(ship.Duty),
      Title: getOptionsValue(ship.Title),
      Shipping_Type: getOptionsValue(ship.Shipping_Type),
      Deliver_End: getOptionsValue(ship.Deliver_End),
      Deliver_Start: getOptionsValue(ship.Deliver_Start),
    }))
  }
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    dispatch({ type: REQUEST_CREATING_CUSTOMER });
    let data = {
      CustomerNum,
      RefNum,
      Name,
      Description,
      ContactName,
      website,
      IsWholesale,
      IsShowPrice,
      CreditLimit,
      CreditStatus,
      OrderType,
      PriceLevel,
      IsActive,
      DeliverPlan_id,
      IsPrtReminder,
      IsPrtGeneralInfor,
      Sales_User_id,
      Sales_User_id2,
      PaymentTerm_id,
      Notation,
      TeapplixCollectShippingProfile,
      Teapplix3rdPartyShippingProfile,
      Commission,
      Commission2,
      Note,
      Shipping,
      Mailing,
      Billing,
      BusinessType,
      IsStripe,
      Wholesale_ResaleNo,
      EIN,
      rating,
      OverdueTime,
      GracePeriod,
      OverdueAmount,
      DLN,
      Reseller,
      MemberCard,
      Sub_Customer_id,
      DiscountPercentage,
      Company_id: selectedCompany.value,
      Attachment1,
      Attachment2,
      Attachment3,
      Attachment4,
      Attachment5,
      Attachment6,
      Attachment7,
      Attachment8,
      AttachmentName1,
      AttachmentName2,
      AttachmentName3,
      AttachmentName4,
      AttachmentName5,
      AttachmentName6,
      AttachmentName7,
      AttachmentName8,
      bad_credit_reason,
      Customer_Service_id,
      AssociatedCompany,
      Old_Customer_id,
      Supervisor_id,
      CreateDate,
      StartDate,
      IsInternal,
      Route_id,
      Discount,
    }
    if(!isOLG) {
      data.email = email;
    }
    if(isOLG) {
      if(Business_Phone) {
        data.Business_Phone = Business_Phone;
      }
      if(email && email.length > 0) {
        data.email = email;
      }
    }
    if(isLAP) {
      data.IsEmailInvoice = IsEmailInvoice;
    }
    if(isVAK && QuickbookAccount && selectedCompany.value == 6) {
      data.QuickbookAccount = QuickbookAccount;
    }
    axios.post(
      CUSTOMERS_URL,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(createCustomerSuccess());
        browserHistory.push('/customers');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(createCustomerFailure(err));          
        }
      });
  };
}

// Edit Customer
export function editCustomerSuccess() {
  return {
    type: EDIT_CUSTOMER_SUCCESS,
  };
}
export function editCustomerFailure(error) {
  return {
    type: EDIT_CUSTOMER_FAILURE,
    payload: error,
  };
}
export function editCustomer({
  Customer_id,
  CustomerNum,
  RefNum,
  Name,
  Description,
  ContactName,
  website,
  IsWholesale,
  IsShowPrice,
  IsEmailInvoice,
  CreditLimit,
  PriceLevel,
  IsActive,
  DeliverPlan_id,
  IsPrtReminder,
  IsPrtGeneralInfor,
  Sales_User_id,
  Sales_User_id2,
  PaymentTerm_id,
  Notation,
  TeapplixCollectShippingProfile,
  Teapplix3rdPartyShippingProfile,
  Commission,
  Commission2,
  Note,
  Shipping,
  Mailing,
  Billing,
  email,
  Wholesale_ResaleNo,
  EIN,
  rating,
  OverdueTime,
  GracePeriod,
  OverdueAmount,
  DLN,
  Reseller,
  MemberCard,
  DiscountPercentage,
  bad_credit_reason,
  Customer_Service_id,
  AssociatedCompany,
  Old_Customer_id,
  Supervisor_id,
  CreateDate,
  StartDate,
  IsInternal, 
  Route_id,
  Business_Phone = '',
  Discount,
  QuickbookAccount = '',
}, { businessType: BusinessType, creditStatus: CreditStatus, orderType: OrderType,IsStripe, Sub_Customer_id,
  Attachment1,
  Attachment2,
  Attachment3,
  Attachment4,
  Attachment5,
  AttachmentName1,
  AttachmentName2,
  AttachmentName3,
  AttachmentName4,
  AttachmentName5,
}) {
  // if(ControlledMailingAddress) {
  //   MailingAddress = {...ControlledMailingAddress};
  // }
  // if(ControlledMailingContact) {
  //   MailingContact = {...ControlledMailingContact};
  // }
  // if(ShippingAddress && currentShippingAddress) {
  //   if(ShippingAddress[0] && currentShippingAddress) {
  //     ShippingAddress[0] = {...ShippingAddress[0], ...currentShippingAddress};
  //   }
  // }
  // if(ShippingContact && currentShippingContact) {
  //   if(ShippingContact[0] && currentShippingContact) {
  //     ShippingContact[0] = currentShippingContact;
  //   }
  // }
  if (Supervisor_id && Supervisor_id.value) {
    Supervisor_id = Supervisor_id.value
  }
  if (rating && rating.value) {
    rating = rating.value
  }
  if (Customer_Service_id && Customer_Service_id.value) {
    Customer_Service_id = Customer_Service_id.value;
  }
  if (AssociatedCompany && AssociatedCompany.value) {
    AssociatedCompany = AssociatedCompany.value;
  }
  if (PaymentTerm_id) {
    PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
  }
  if (Sales_User_id) {
    Sales_User_id = Sales_User_id.value || Sales_User_id;
  }
  if (Sales_User_id2) {
    Sales_User_id2 = Sales_User_id2.value || Sales_User_id2;
  }
  if (Billing && Billing.Duty && Billing.Duty.value) {
    Billing.Duty = Billing.Duty.value;
  }
  if (Billing && Billing.Title && Billing.Title.value) {
    Billing.Title = Billing.Title.value;
  }
  if (Mailing && Array.isArray(Mailing)) {
    Mailing = Mailing.map(mail => ({
      ...mail,
      Duty: getOptionsValue(mail.Duty),
      Title: getOptionsValue(mail.Title),
    }))
  }
  if (Shipping && Array.isArray(Shipping)) {
    Shipping = Shipping.map(ship => ({
      ...ship,
      Duty: getOptionsValue(ship.Duty),
      Title: getOptionsValue(ship.Title),
      Shipping_Type: getOptionsValue(ship.Shipping_Type),
      Deliver_End: getOptionsValue(ship.Deliver_End),
      Deliver_Start: getOptionsValue(ship.Deliver_Start),
    }))
  }
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    dispatch({ type: REQUEST_EDITING_CUSTOMER });
    let data = {
      CustomerNum,
      RefNum,
      Name,
      Description,
      ContactName,
      website,
      IsWholesale,
      IsShowPrice,
      CreditLimit,
      CreditStatus,
      OrderType,
      PriceLevel,
      IsActive,
      DeliverPlan_id,
      IsPrtReminder,
      IsPrtGeneralInfor,
      Sales_User_id,
      Sales_User_id2,
      PaymentTerm_id,
      Notation,
      TeapplixCollectShippingProfile,
      Teapplix3rdPartyShippingProfile,
      Commission,
      Commission2,
      Note,
      Shipping,
      Mailing,
      Billing,
      BusinessType,
      IsStripe,
      Wholesale_ResaleNo,
      EIN,
      rating,
      OverdueTime,
      GracePeriod,
      OverdueAmount,
      DLN,
      Reseller,
      MemberCard,
      Sub_Customer_id,
      DiscountPercentage,
      Company_id: selectedCompany.value,
      Attachment1,
      Attachment2,
      Attachment3,
      Attachment4,
      Attachment5,
      AttachmentName1,
      AttachmentName2,
      AttachmentName3,
      AttachmentName4,
      AttachmentName5,
      bad_credit_reason,
      Customer_Service_id,
      AssociatedCompany,
      Old_Customer_id,
      Supervisor_id,
      CreateDate,
      StartDate,
      IsInternal,
      Route_id,
      Discount,
    }
    if(!isOLG) {
      data.email = email;
    }
    if(isOLG) {
      if(Business_Phone) {
        data.Business_Phone = Business_Phone;
      }
      if(email && email.length > 0) {
        data.email = email;
      }
    }
    if(isLAP) {
      data.IsEmailInvoice = IsEmailInvoice;
    }
    if ( Discount==='' ) {
      data.Discount = null;
    }

    if(isVAK && QuickbookAccount && selectedCompany.value == 6) {
      data.QuickbookAccount = QuickbookAccount;
    }
    
    axios.put(
      (CUSTOMERS_URL + Customer_id),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(editCustomerSuccess());
        browserHistory.push('/customers'); // If editd succesfully, refresh the paymentTerm page.
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editCustomerFailure(err));          
        }
      });
  };
}


export function editCustomerGroup({
  Customer_id,
  CustomerGroup_id,
}) {
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_CUSTOMER });
    axios.put(
      (CUSTOMERS_URL + Customer_id),
      {
        CustomerGroup_id,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(editCustomerSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editCustomerFailure(err));          
        }
      });
  };
}

export function requestEditingCustomer() {
  return {
    type: REQUEST_EDITING_CUSTOMER,
  };
}

// Fetch the detail page.
export function requestCustomerDetail() {
  return {
    type: REQUEST_CUSTOMER_DETAIL,
  };
}
export function fetchCustomerDetailSuccess(customerDetail) {
  return {
    type: FETCH_CUSTOMER_DETAIL_SUCCESS,
    payload: customerDetail,
  };
}
export function fetchCustomerDetailFailure(error) {
  return {
    type: FETCH_CUSTOMER_DETAIL_FAILURE,
    payload: error,
  };
}
export function fetchCustomerDetail(customer_id) {
  return (dispatch) => {
    dispatch(requestCustomerDetail());
    return axios.get(
      CUSTOMERS_URL + customer_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchCustomerDetailFailure(err));          
        }
      });
  };
}

// fetch Customer Credit By Date
export function requestCustomerCreditByDate() {
  return {
    type: REQUEST_CUSTOMER_CREDIT_BY_DATE,
  };
}

export function fetchCustomerCreditByDateSuccess(customerDetail) {
  return {
    type: FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS,
    payload: customerDetail,
  };
}
export function fetchCustomerCreditByDateFailure(error) {
  return {
    type: FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE,
    payload: error,
  };
}
export function fetchCustomerCreditByDate(date) {
  return (dispatch) => {
    dispatch(requestCustomerCreditByDate());
    return axios.get(
      CUSTOMER_CREDIT_LINES_URL + date,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerCreditByDateSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchCustomerCreditByDateFailure(err));          
        }
      });
  };
}

// Fetch Customers Status
export function fetchCustomersStatusSuccess(statuses) {
  return {
    type: FETCH_CUSTOMERS_STATUS_SUCCESS,
    payload: statuses,
  };
}
export function fetchCustomersStatusFailure(error) {
  return {
    type: FETCH_CUSTOMERS_STATUS_FAILURE,
    payload: error,
  };
}
export function fetchCustomersStatus() {
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMERS_STATUS });
    return axios.get(
      CUSTOMERS_STATUS_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomersStatusSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchCustomersStatusFailure(err));          
        }
      });
  };
}

// Attach Document
export function attachDocumentSuccess() {
  return {
    type: ATTACH_DOCUMENT_SUCCESS,
  };
}
export function attachDocumentFailure(error) {
  return {
    type: ATTACH_DOCUMENT_FAILURE,
    payload: error,
  };
}
export function attachDocument(files) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedComapny = state.header.selectedCompany;

    dispatch({ type: ATTACH_DOCUMENT });
    let data = new FormData();
    data.append('customer_file', files[0]);

    return axios.post(
      `${UPLOAD_URL}customer/${selectedComapny.value}`, data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(attachDocumentSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(attachDocumentFailure(err));          
        }
      });
  };
}

export function fetchFJAgents(customer) {
  const url = `${FETCH_FJ_AGENTS_URL}${customer}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function updateFJAgents(customer, agentsArray) {
  let output = [];
  agentsArray.map(r => {
    if (r.name) {
      output.push(r);
    }
  });
  // if (output.length === 0) {
  //   alert("Must have at least one valid agent name");
  //   return;
  // }
  const url = `${FETCH_FJ_AGENTS_URL}${customer}`;
  return (dispatch) => {
    return axios({
      method: 'post',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function deleteFJAgents(agent) {
  const url = `${FETCH_FJ_AGENTS_URL}${agent}`;
  return (dispatch) => {
    return axios({
      method: 'delete',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}


export function fetchPT(customer, day, selectedWarehouse) {
  let url = `${FETCH_PRICE_TABLE_URL}${customer}`;
  if (isLE) {
    url = `${FETCH_PRICE_TABLE_URL}${customer}/${day}?warehouse_id=${selectedWarehouse.value}`;
  }
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function updatePT(customer, priceArray, selectedDay, selectedWarehouse) {
  // let output = [];
  // priceArray.map(r => {
  //   if (r.name) {
  //     output.push(r);
  //   }
  // });
  let output = {fees: priceArray};
  let url = `${FETCH_PRICE_TABLE_URL}${customer}`;
  if (isLE) {
    url = `${FETCH_PRICE_TABLE_URL}${customer}/${selectedDay}?warehouse_id=${selectedWarehouse.value}`;
  }
  return (dispatch) => {
    return axios({
      method: 'post',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export const generateCustomerNoWithBusinessType = (params, success) => dispatch => {
  axios({
    method: 'GET',
    url: `${CUSTOMERS_URL}get_customer_number`,
    params,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    success(res.data);
  }).catch(err => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      alert(err);      
    }
  })
}

export const generateRefNoWithBusinessType = (params, success) => dispatch => {
  axios({
    method: 'GET',
    url: `${CUSTOMERS_URL}get_ref_number`,
    params,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    success(res.data);
  }).catch(err => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      alert(err);      
    }
  })
}

export function getAutoCustomerNumber(success) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    const companyId = selectedCompany ? selectedCompany.value : null;
    if (!companyId) {
      return
    }
    axios({
      method: 'get',
      url: AUTO_CUSTOMER_NUMBER_URL,
      params: {
        company_id: companyId
      },
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        success(res.data);
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          alert(err);      
        }
      });
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/customers_actions.js